module.exports = __webpack_public_path__ + "static/media/Daario Naharis 3.28d57e6f.jpg";